import { render, staticRenderFns } from "./wiki-category-description.vue?vue&type=template&id=5a1904b6&"
import script from "./wiki-category-description.vue?vue&type=script&lang=ts&"
export * from "./wiki-category-description.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports